document.addEventListener('DOMContentLoaded', () => {
  console.log('Initializing infinite scroll');
  
  // Config
  const productGrid = document.getElementById('product-grid');
  if (!productGrid) {
    console.error('Product grid not found, aborting infinite scroll');
    return; // Exit if product grid doesn't exist
  }
  
  let currentPage = 1;
  let isLoading = false;
  let hasMorePages = true;
  
  // Get collection URL from the current URL
  const collectionUrl = window.location.pathname;
  console.log('Collection URL:', collectionUrl);
  
  // Create loading spinner
  const loadingSpinner = document.createElement('div');
  loadingSpinner.className = 'loading-indicator';
  loadingSpinner.innerHTML = `
    <div class="loading-overlay__spinner">
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
  `;
  
  // Function to check if we should load more
  function checkForMoreProducts() {
    if (isLoading || !hasMorePages) return;
    
    // Get the last product item
    const productItems = productGrid.querySelectorAll('li');
    if (productItems.length === 0) return;
    
    const lastProduct = productItems[productItems.length - 1];
    const lastProductRect = lastProduct.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Load more when the last product is partially visible in the viewport
    // This means its top edge has entered the viewport
    if (lastProductRect.top < windowHeight) {
      console.log('Last product is partially visible, loading more products');
      loadMoreProducts();
    }
  }
  
  // Function to load more products
  function loadMoreProducts() {
    isLoading = true;
    currentPage++;
    console.log('Loading page:', currentPage);
    
    // Set the loading flag for global.js
    window.isLoadingMoreProducts = true;
    
    // Append loading spinner
    const collectionElement = document.querySelector('.collection');
    if (collectionElement) {
      collectionElement.appendChild(loadingSpinner);
    }
    
    // Fetch next page
    console.log('Fetching URL:', `${collectionUrl}?page=${currentPage}&section_id=main-collection-product-grid`);
    fetch(`${collectionUrl}?page=${currentPage}&section_id=main-collection-product-grid`)
      .then(response => response.text())
      .then(html => {
        // Remove loading spinner
        loadingSpinner.remove();
        
        // Parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.getElementById('product-grid');
        
        // If we got results, append them
        if (newProducts && newProducts.children.length > 0) {
          console.log('Found', newProducts.children.length, 'new products');
          
          // Clone each product and append to grid
          Array.from(newProducts.children).forEach(item => {
            const clone = item.cloneNode(true);
            
            // Make sure product descriptions are initially hidden
            const productDescription = clone.querySelector('.product-description');
            if (productDescription) {
              productDescription.style.display = 'none';
            }
            
            productGrid.appendChild(clone);
          });
          
          // Tell the browser to execute any scripts in the new content
          console.log('Executing scripts for new content');
          executeScripts();
          
          // Initialize product quick add if enabled
          if (typeof window.quickAddInit === 'function') {
            console.log('Initializing quick add');
            window.quickAddInit();
          }
          
          // Clear the loading flag
          window.isLoadingMoreProducts = false;
          
          // Manually trigger initialization after a delay
          setTimeout(() => {
            if (typeof window.initializePlusElements === 'function') {
              console.log('Manually triggering initializePlusElements after delay');
              window.initializePlusElements();
            }
          }, 300);
        } else {
          console.log('No more products found');
          hasMorePages = false;
          window.isLoadingMoreProducts = false;
        }
        
        isLoading = false;
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        loadingSpinner.remove();
        isLoading = false;
        window.isLoadingMoreProducts = false;
      });
  }
  
  // Helper function to execute scripts in the newly added content
  function executeScripts() {
    // This function will help ensure that any theme scripts run on the new content
    // Many Shopify themes will automatically reattach event listeners on DOM changes
    
    // Dispatch a custom event that your theme might listen for
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
    console.log('Dispatched shopify:section:load event');
    
    // If your theme uses jQuery, you might need this
    if (typeof jQuery !== 'undefined') {
      jQuery(document).trigger('shopify:section:load');
      console.log('Triggered jQuery shopify:section:load event');
    }
  }
  
  // Add scroll event listener with throttling to improve performance
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    
    scrollTimeout = setTimeout(checkForMoreProducts, 100);
  });
  console.log('Added scroll event listener');
  
  // Add some CSS for the loading spinner
  const style = document.createElement('style');
  style.textContent = `
    .loading-indicator {
      text-align: center;
      padding: 20px 0;
      width: 100%;
    }
    .loading-overlay__spinner {
      display: inline-block;
    }
    .spinner {
      width: 40px;
      height: 40px;
      animation: spinner 1s linear infinite;
      color: #7a7d80;
    }
    @keyframes spinner {
      to {transform: rotate(360deg);}
    }
    .path {
      stroke: currentColor;
    }
  `;
  document.head.appendChild(style);
  console.log('Added spinner CSS');
  
  console.log('Infinite scroll initialized');
});